import actionTypes from './actionTypes'

const cookiesActions = {
	retry: () => ({
		type: actionTypes.USER_COOKIE_BLOCKED_RETRY,
	}),

	goToLearnMore: () => ({
		type: actionTypes.USER_COOKIE_BLOCKED_LEARN_MORE,
	}),

	cookiesDisabledConfirmRetry: () => ({
		type: actionTypes.COOKIES_DISABLED_CONFIRM_RETRY,
	}),
	closeCookiesDisabledConfirm: () => ({
		type: actionTypes.COOKIES_DISABLED_CLOSE_CONFIRM,
	}),
	cookieTestFailed: error => ({
		type: actionTypes.USER_COOKIE_BLOCKED_FAILED,
		error,
	}),
}

export default cookiesActions
